import { Component, ElementRef, ViewChild } from '@angular/core';
import { HelpMeClient } from '../HelpMeClient';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelpMePopupComponent } from '../help-me-popup/help-me-popup.component';
import { StorageService } from '../../../core/storage/storageService';
import { Router } from '@angular/router';

@Component({
  selector: 'app-help-me-client-button',
  templateUrl: './help-me-client-button.component.html',
  standalone: false,
})
export class HelpMeClientButtonComponent {
  public isVisible: boolean = false;

  private clientUserId: string = '2';

  private pollId: number | undefined = undefined;
  private INTERVAL_LISTEN_FOR_REQUEST: number = 3000;
  //private session: HelpMeClient | void = undefined;
  //private sessionId: string | undefined = undefined;

  private helpMeClient: HelpMeClient | undefined;
  public isSessionActive: boolean = false;

  //private pointer: any;
  private pointerSize: any;

  constructor(
    private dialog: MatDialog,
    private storageService: StorageService,
    private router: Router,
  ) {
    try {
      let currentUser = storageService.getCurrentUser();
      //let currentRoles = storageService.getCurrentRoles();

      // TODO (jacob): make sure this role exists
      this.isVisible = false; //currentRoles["portal.helpme.client-r"];

      if (this.isVisible) {
        this.helpMeClient = HelpMeClient.initialize(this.clientUserId, this);
      }
    } catch (e) {
      debugger;
      console.error(e);
      this.router.navigate(['signin']);
    }
  }

  public heardInvite(client: HelpMeClient) {
    this.helpMeClient = client;
    this.isSessionActive = true;
    this.openSessionDetails({
      pendingInvite: true,
    });
  }

  /*
  @ViewChild('pointer', { static: false}) set chatWindowContent(content: ElementRef) {
    if (content) {
        let oPointer = content;
        this.pointer = oPointer.nativeElement;

        //this.pointerSize = {width:this.pointer.width(), height: this.pointer.height()};
        this.pointerSize = { width:50, height:34};

      }
  }
     */
  @ViewChild('pointer') pointer: ElementRef = ElementRef.prototype;

  btnOpenDetails_click() {
    this.openSessionDetails({
      sessionId: this.helpMeClient?.sessionId,
      isSupport: false,
    });
  }

  public openSessionDetails(data: any) {
    let dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.height = '400px';
    dialogConfig.data = data;
    dialogConfig.hasBackdrop = false; // this makes it non-modal
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(HelpMePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.event == 'AcceptInvite') {
        this.acceptRequest();
        this.isSessionActive = true;
      }
      //else if (result.event == "EndSession") {
      //  this.endSession();
      //}
    });
  }

  //public getActiveSession(): HelpMeSession | void {
  //    return this.session;
  //}

  public acceptRequest() {
    console.log('Accepted request... joining session');
    this.helpMeClient?.joinSession(this.pointer, this.pointerSize, this.router);
  }

  public endedSessionCallback() {
    this.openSessionDetails({
      sessionEnded: true,
    });
  }

  //public endSession() {
  //  this.helpMeClient?.endSession();
  //    //this.startListeningForRequest();
  //}

  /*
private startListeningForRequest() {
    let that = this;
    this.pollId = window.setInterval(function() {that.listenForRequest();}, this.INTERVAL_LISTEN_FOR_REQUEST);
    console.log("HelpMe! Client is listening for incoming requests to join...");        
}

public async listenForRequest() {

  console.log("Looking for session...");

  this.helpMeClient = await HelpMeClient.getPendingSession(this.clientUserId);

  if (this.helpMeClient != undefined) {
    console.log("Client heard invite for session #" + this.helpMeClient.sessionId);

    window.clearInterval(this.pollId);

    this.isSessionActive = true; 
    this.openSessionDetails({
      pendingInvite: true
    });
  }
}
     */
}
